import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const LEContactName = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.leContactName"
      control={control}
      render={({ field }) => (
        <FF2 label="90. LE contact name" field={field} input={(props) => <TextInput {...props} />} />
      )}
    />
  )
}
